import { render, staticRenderFns } from "./FormAssetRegion.vue?vue&type=template&id=f5252fda&lang=pug"
import script from "./FormAssetRegion.vue?vue&type=script&lang=js"
export * from "./FormAssetRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports